(function () {
  'use strict';

  var script = document.currentScript;
  var cartPath = script && script.getAttribute('data-cart-url');
  var pluginOrigin = script && script.getAttribute('data-plugin-origin');
  var designMode = script && script.getAttribute('data-design-mode') === 'true';
  var redirecting = false;
  var currentNonce = '';
  var retryTimer = null;
  var activeIframe = null;

  if (!cartPath || !pluginOrigin || designMode || (window.Shopify && window.Shopify.designMode)) return;

  var cartUrl;
  try {
    cartUrl = new URL(cartPath, window.location.origin);
    if (cartUrl.origin !== window.location.origin) return;
    cartUrl = cartUrl.toString();
  } catch (e) {
    return;
  }

  function createNonce() {
    var bytes = new Uint8Array(16);

    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
      return Array.prototype.map.call(bytes, function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    }

    return String(Date.now()) + '-' + Math.random().toString(16).slice(2);
  }

  function sendBridgeInit() {
    if (!activeIframe || !activeIframe.contentWindow || !currentNonce) return;

    try {
      activeIframe.contentWindow.postMessage({
        type: 'CUSPRINT_CART_BRIDGE_INIT',
        version: 1,
        nonce: currentNonce,
        cartUrl: cartUrl
      }, pluginOrigin);
    } catch (e) {
      // The child keeps its own trusted Shopify cart fallback if messaging fails.
    }
  }

  function beginHandshake(iframe) {
    activeIframe = iframe;
    currentNonce = createNonce();
    window.clearInterval(retryTimer);
    sendBridgeInit();

    var attempts = 0;
    retryTimer = window.setInterval(function () {
      if (redirecting || attempts >= 4) {
        window.clearInterval(retryTimer);
        retryTimer = null;
        return;
      }

      attempts += 1;
      sendBridgeInit();
    }, 250);
  }

  function clearHandshake(iframe) {
    if (iframe && iframe !== activeIframe) return;

    activeIframe = null;
    currentNonce = '';
    window.clearInterval(retryTimer);
    retryTimer = null;
  }

  function bindProductIframe() {
    var iframe = document.getElementById('cuswebIframe');
    if (!iframe || iframe.__cusprintCartBridgeBound) return;

    iframe.__cusprintCartBridgeBound = true;
    iframe.addEventListener('load', function () {
      beginHandshake(iframe);
    });
    beginHandshake(iframe);
  }

  window.addEventListener('message', function (event) {
    var data = event.data || {};

    if (redirecting || event.origin !== pluginOrigin || !activeIframe) return;
    if (activeIframe.isConnected === false) {
      clearHandshake(activeIframe);
      return;
    }
    if (event.source !== activeIframe.contentWindow) return;
    if (data.type !== 'CUSPRINT_CART_READY' || data.version !== 1 || data.nonce !== currentNonce) return;

    redirecting = true;
    window.clearInterval(retryTimer);
    window.location.assign(cartUrl);
  });

  bindProductIframe();
  document.addEventListener('shopify:section:load', bindProductIframe);
  document.addEventListener('shopify:section:unload', function (event) {
    if (!activeIframe || !event.target || typeof event.target.contains !== 'function') return;
    if (event.target.contains(activeIframe)) clearHandshake(activeIframe);
  });
})();
